import { apiClient } from "../../lib";

export interface User {
  user_id: number;
  cognito_id: string;
  email: string;
  first_name: string;
  last_name: string;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string | null;
  preferred_username: string;
  layout_id: number;
  access_details: unknown | null;
  contact_no: string | null;
  is_active: string;
}

export interface GetUsersResponse {
  status: boolean;
  http_code: number;
  message: string;
  response_time: string;
  meta_data: string;
  data: User[];
}

export interface GetUserResponse {
  status: boolean;
  http_code: number;
  message: string;
  response_time: string;
  meta_data: string;
  data: User;
}

export const usersApi = {
  getUsers: async (): Promise<GetUsersResponse> => {
    const response = await apiClient.get("/users");
    return response.data;
  },
  getUser: async (userId: number): Promise<GetUserResponse> => {
    const response = await apiClient.get(`/users/${userId}`);
    return response.data;
  },
  getStakeholders: async ({ params }: { params?: Record<string, any> }): Promise<GetUsersResponse> => {
    const response = await apiClient.get("/projects/stakeholders-dropdown" , { params });
    return response.data;
  },
};
